import * as z from "zod/v4";

export const disconnectReturnsTiktokIntegration = {
  name: "disconnectReturnsTiktokIntegration" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
